<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" v-bind:style="{ width: width }" @click.stop>
          <button class="modal-default-button" @click="closeModal" id="modal1">
            X
          </button>
          <div class="modal-header">
            <h3 style="padding-left: 25px;">{{ title }}</h3>
          </div>
          <div class="modal-body">
            <component :is="component" :data="data" v-on:close="closeModal"></component>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  import AddressMap from '../GeneralViews/Modal/AddressMap'
  import AllUsersCalendar from '../Dashboard/Views/Users/Modal/AllUsersCalendar'
  import ArchiveFileBrowser from '../Dashboard/Views/Files/Modal/ArchiveFileBrowser'
  import Calendar from '../Dashboard/Views/Users/Modal/Calendar'
  import CamundaIncidents from '../Dashboard/Views/Jobs/Modal/CamundaIncidents'
  import City from '../Dashboard/Views/Cities/Modal/City'
  import ChangeAssignment from '../Dashboard/Views/InspectorRouting/Modal/ChangeAssignment'
  import Community from '../Dashboard/Views/Communities/Modal/Community'
  import ConfirmDelete from '../GeneralViews/Modal/ConfirmDelete'
  import ConfirmSaveAssignments from '../Dashboard/Views/InspectorRouting/Modal/ConfirmSaveAssignments'
  import CreateDeployments from '../Dashboard/Views/Camunda/Modal/CreateDeployments'
  import CreateJobWizard from '../Dashboard/Views/Jobs/Modal/CreateJobWizard'
  import CreateProject from '../Dashboard/Views/Projects/Modal/CreateProject'
  import CreateProjectAndJobWizard from '../Dashboard/Views/Projects/Modal/ProjectAndJobWizard/CreateProjectAndJobWizard'
  import Comments from '../Dashboard/Views/Comments/Modal/Comments'
  import Constants from 'src/utilities/constants'
  import DeleteDeployments from '../Dashboard/Views/Camunda/Modal/DeleteDeployments'
  import DownloadInProgress from '../Dashboard/Views/Files/Modal/DownloadInProgress'
  import DownloadToExcel from '../Dashboard/Views/Tasks/Modal/DownloadToExcel.vue'
  import EditDescription from '../Dashboard/Views/SupplyPro/Modal/EditDescription'
  import EditJob from '../Dashboard/Views/Jobs/Modal/EditJob'
  import EditProjectDepartments from '../Dashboard/Views/Projects/Modal/EditProjectDepartments'
  import EditUser from '../Dashboard/Views/Users/Modal/EditUser'
  import FileDetails from '../Dashboard/Views/Files/Modal/FileDetails'
  import FileBrowser from '../Dashboard/Views/Files/Modal/FileBrowser'
  import FormField from '../Dashboard/Views/InspectorApp/Modal/FormField'
  import FormFieldBlock from '../Dashboard/Views/InspectorApp/Modal/FormFieldBlock'
  import ImportTaskName from '../Dashboard/Views/TaskNames/Modal/ImportTaskName'
  import ImportTaskTemplate from '../Dashboard/Views/TaskTemplates/Modal/ImportTaskTemplate'
  import Invoice from '../Dashboard/Views/Invoices/Modal/Invoice'
  import InvoicesLoading from '../Dashboard/Views/Invoices/Modal/InvoicesLoading'
  import ItemCode from '../Dashboard/Views/QuickBooks/Modal/ItemCode'
  import JobProgress from '../Dashboard/Views/Camunda/Modal/ViewProcessInstance'
  import JobSearchResults from '../Dashboard/Views/Jobs/Modal/PrintSearchResults'
  import LegalSubdivision from '../Dashboard/Views/LegalSubdivisions/Modal/LegalSubdivision'
  import ManageSavedSearches from '../GeneralViews/Modal/ManageSavedSearches'
  import Metadata from '../Dashboard/Views/Metadata/Modal/Metadata'
  import ChangePurchaseOrder from '../Dashboard/Views/SupplyPro/Modal/ChangePurchaseOrder'
  import NoProjectResultsFound from '../Dashboard/Views/Projects/Modal/NoProjectResultsFound'
  import NoResultsFound from '../GeneralViews/Modal/NoResultsFound'
  import NoInvoicesFound from '../GeneralViews/Modal/NoInvoicesFound'
  import PleaseWait from '../GeneralViews/Modal/PleaseWait'
  import PreviewInvoices from '../Dashboard/Views/Invoices/Modal/PreviewInvoices'
  import PriceRule from '../Dashboard/Views/PriceRules/Modal/PriceRule'
  import PrintMyTasks from '../Dashboard/Views/Tasks/Modal/PrintMyTasks'
  import ProcessDefinition from '../Dashboard/Views/Camunda/Modal/ProcessDefinition'
  import ProcessDefinitions from '../Dashboard/Views/Camunda/Modal/ProcessDefinitions'
  import ProjectSearchResults from '../Dashboard/Views/Projects/Modal/PrintSearchResults'
  import ReplaceJob from '../Dashboard/Views/Jobs/Modal/ReplaceJob'
  import Requeue from '../Dashboard/Views/Dashboard/Modal/Requeue'
  import SearchAndSortPreferences from '../GeneralViews/Modal/SearchAndSortPreferences'
  import SolverConfiguration from '../Dashboard/Views/InspectorRouting/Modal/SolverConfiguration'
  import Tag from '../Dashboard/Views/InspectorApp/Modal/Tag'
  import TasksLoading from '../Dashboard/Views/Tasks/Modal/TasksLoading'
  import TaskName from '../Dashboard/Views/TaskNames/Modal/TaskName'
  import TaskTemplate from '../Dashboard/Views/TaskTemplates/Modal/TaskTemplate'
  import TaskSearchResults from '../Dashboard/Views/Tasks/Modal/PrintSearchResults'
  import TerminateCamundaProcess from '../Dashboard/Views/Jobs/Modal/TerminateCamundaProcess'
  import TerminateJobs from '../Dashboard/Views/Tasks/Modal/TerminateJobs'
  import UnassociatedInspectionForms from '../Dashboard/Views/Files/Modal/UnassociatedInspectionForms'
  import UploadForms from '../Dashboard/Views/Files/Modal/UploadForms'
  import ViewLog from '../GeneralViews/Modal/ViewLog'
  import {focusTrap} from 'src/utilities/utils'

  export default {
    props: ['title', 'component', 'data', 'width'],
    components: {
      AddressMap,
      AllUsersCalendar,
      ArchiveFileBrowser,
      Calendar,
      CamundaIncidents,
      ChangePurchaseOrder,
      ChangeAssignment,
      City,
      Comments,
      Community,
      ConfirmDelete,
      ConfirmSaveAssignments,
      CreateDeployments,
      CreateJobWizard,
      CreateProject,
      CreateProjectAndJobWizard,
      DeleteDeployments,
      DownloadInProgress,
      DownloadToExcel,
      EditProjectDepartments,
      EditDescription,
      EditJob,
      EditUser,
      FileBrowser,
      FileDetails,
      FormField,
      FormFieldBlock,
      ImportTaskName,
      ImportTaskTemplate,
      Invoice,
      InvoicesLoading,
      ItemCode,
      JobProgress,
      JobSearchResults,
      LegalSubdivision,
      ManageSavedSearches,
      Metadata,
      NoProjectResultsFound,
      NoResultsFound,
      NoInvoicesFound,
      PleaseWait,
      ProcessDefinition,
      ProcessDefinitions,
      PreviewInvoices,
      PrintMyTasks,
      PriceRule,
      ProjectSearchResults,
      ReplaceJob,
      Requeue,
      SearchAndSortPreferences,
      SolverConfiguration,
      Tag,
      TasksLoading,
      TaskName,
      TaskTemplate,
      TaskSearchResults,
      TerminateCamundaProcess,
      TerminateJobs,
      UnassociatedInspectionForms,
      UploadForms,
      ViewLog
    },
    methods: {
      closeModal() {
        this.maybeResetQuerystringParams()
        this.$emit('close')
      },
      // the following querystring params are used in a watcher in ProjectContainer.vue
      // and set by ViewProcessInstance.vue. They need to be reset back to nothing when the Modal is closed
      // so subsequent clicks on user tasks trigger a change in the URL which triggers re-opening the Modal
      // with the selected task
      maybeResetQuerystringParams() {
        let replace = false
        let query = Object.assign({}, this.$route.query)
        if (query.hasOwnProperty('taskId')) {
          delete query.taskId
          replace = true
        }
        if (query.hasOwnProperty('processInstanceId')) {
          delete query.processInstanceId
          replace = true
        }
        if (query.hasOwnProperty('taskNameKey')) {
          delete query.taskNameKey
          replace = true
        }
        if (query.hasOwnProperty('taskTemplateKey')) {
          delete query.taskTemplateKey
          replace = true
        }
        if (query.hasOwnProperty('cp')) {
          delete query.cp
          replace = true
        }
        if (replace) {
          this.$router.replace({ query })
        }
      }
    },
    mounted() {
      document.addEventListener('keydown', (e) => {
        if (e.keyCode === Constants.ESCAPE_KEY) {
          this.$emit('close')
        }
      })
      focusTrap('modal1', this.component)
      this.$store.set('modalTracker/modal1', this.component)
    },
    beforeDestroy() {
      this.$store.set('modalTracker/modal1', null)
      this.maybeResetQuerystringParams()
    },
    watch: {
      'component': {
        handler: function () {
          this.$store.set('modalTracker/modal1', this.component)
        }
      }
    }
  }
</script>
<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 1090; /*must be less than 100 to be behind notifications*/
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    z-index: 1091; /*must be less than 100 to be behind notifications*/
  }

  .modal-container {
    width: 74%;
    max-height: calc(100vh - 50px);
    max-width: calc(100vw - 50px);
    margin: 0 auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    z-index: 999;
  }

  .modal-header, .modal-footer {
    border: none;
    padding: 0;
  }
  .modal-header h3 {
    margin: 0;
    padding: 0;
  }

  .modal-body {
    padding: 0;
    margin: 10px 0;
  }

  .modal-default-button {
    float: right;
    z-index: 100000;
  }

  /*
   * The following styles are auto-applied to elements with
   * transition="Modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the Modal transition by editing
   * these styles.
   */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
</style>
